import { Pipe, PipeTransform } from '@angular/core';
import { AssetStatus } from '@picflow/types';

export const getAssetStatusName = (status: AssetStatus): string => {
  if (status === 'approved') return 'Approved';
  if (status === 'in_progress') return 'In Progress';
  if (status === 'needs_review') return 'Needs Review';
  if (status === 'rejected') return 'Rejected';
  return 'No status';
};

@Pipe({
  name: 'assetStatusName',
  standalone: true,
})
export class AssetStatusNamePipe implements PipeTransform {
  transform(status: AssetStatus): string {
    return getAssetStatusName(status);
  }
}
